import React from 'react'
import SubHeader from '../../components/SubHeader'
import ProjectCard from './ProjectCard'

export default function ProjectListing({initialData}) {
    const subheadData = {
        image: '../assets/images/news-banner.webp',
        pagename: 'Projects',
        subhead: 'Trusted by hospitals, hotels, and industrial laundry facilities nationwide.',
    }

    return (
        <>
            <SubHeader subheadData={subheadData} />
            <ProjectCard  initialData={initialData}/>
        </>
    )
}

